export const INIT_USER_HAS_CURRENCY = 'INIT_USER_HAS_CURRENCY';

export function initUserHasCurrency(userHasCurrency){
    return{
        type: INIT_USER_HAS_CURRENCY,
        mainState: {
            userHasCurrency: userHasCurrency
        }
    }
}